const jimboPalette = {
  primary: {
    main: '#CD9BF0',
    light: '#F4E4FF',
    lighter: '#FCF7FF',
  },
  secondary: {
    main: '#161616',
  },
};

export default jimboPalette;
